import React, { useState, useEffect } from "react";
import Header from "../common/Header";
import { useParams } from "react-router-dom";
import apiCall from "../common/Utils/helper";
import Card from "../common/Card";
import SliderPopup from "../Gallery/SliderPopup";
import SharePopup from "./SharePopup";

function FileFolderSearch() {
  const [openFile, setOpenFile] = useState(false);
  const [openFolder, setOpenFolder] = useState(true);
  const [searchResults, setSearchResults] = useState([]);
  const [selectedFileIndex, setSelectedFileIndex] = useState(null);
  const { term, startDate, endDate } = useParams();
  const [showPopup, setShowPopup] = useState(false);
  const [popupId, setPopupId] = useState(null);
  const [popupFolderName, setPopupFolderName] = useState("");
  const [showSlider, setShowSlider] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let endpoint, requestData;
        // alert(term)
        // if (term) {
        endpoint = "/searchpublic";
        requestData = { searchTerm: term };
        if (startDate && endDate) {
          requestData["startDate"] = startDate;
          requestData["endDate"] = endDate;
        }
        // } else if (startDate && endDate) {
        //   endpoint = "/getdatabydaterange";
        //   requestData = {
        //     startDate: startDate,
        //     endDate: endDate,
        //   };
        // }
        const result = await apiCall("post", endpoint, requestData);
        setSearchResults(result.response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [term, startDate, endDate, openFile, openFolder, showSlider]);

  const handleShowFolder = () => {
    setOpenFolder(true);
    setOpenFile(false);
  };

  const handleShowFile = (index) => {
    setOpenFolder(false);
    setOpenFile(true);
    setSelectedFileIndex(index);
    setShowSlider(true);
  };

  const handlePopupClose = () => {
    setShowSlider(false);
    setOpenFile(true);
  };
  const togglePopup = (id, folderName) => {
    setShowPopup(!showPopup);
    setPopupId(id);
    setPopupFolderName(folderName);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };



  return (
    <div>
      <Header  />
      {showPopup && (
        <SharePopup
          onClose={handleClosePopup}
          id={popupId}
          folderName={popupFolderName}
        />
      )}
      <div className="photonav_container">
        <ul className="folder_list">
          <li className={openFolder ? "active" : ""}>
            <button onClick={handleShowFolder}>Folder</button>
          </li>

          <li className={openFile ? "active" : ""}>
            <button onClick={() => handleShowFile(null)}>File</button>
          </li>
        </ul>
      </div>

      <div className="list_section">
        {openFolder && (
          <div className="photonav_container">
            <ul className="card_list card_list_folder">
              {searchResults &&
              searchResults.folders &&
              searchResults.folders.length > 0 ? (
                searchResults.folders.map((folderItem, index) => (
                  <li key={index}>
                    <Card
                      folderName={folderItem.folder_name}
                      assetDate={folderItem.asset_date}
                      folderPaths={folderItem.file_path}
                      folderId={folderItem.folder_id}
                      togglePopup={togglePopup}
                    />
                  </li>
                ))
              ) : (
                <p>No folders available for the searched term.</p>
              )}
            </ul>
          </div>
        )}
        {openFile && selectedFileIndex !== null && showSlider && (
          <SliderPopup
            galleryData={searchResults.files}
            onCancel={handlePopupClose}
            initialIndex={selectedFileIndex}
          />
        )}
        {openFile && (
          <div className="photonav_container">
            <ul className="card_list card_list_folder">
              {searchResults &&
              searchResults.files &&
              searchResults.files.length > 0 ? (
                searchResults.files.map((fileItem, index) => (
                  <li key={index}>
                    <img
                      src={`https://new-dam-java.b-cdn.net/${fileItem.file_path}?width=300`}
                      className="img_banner"
                      alt=""
                      onClick={() => handleShowFile(index)}
                    />
                  </li>
                ))
              ) : (
                <p>No files available for the searched term.</p>
              )}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
export default FileFolderSearch;
